import './index.less';
import { useEffect, useState, useRef, useContext } from 'react';
import classNames from 'classnames';
import { MonitorObjectTypeList } from '@/declare/enums/monitor-object-type';
import { EngineContext, SystemContext } from '@/App';
import Gray from './icons/gray.png';
import Blue from './icons/blue.png';
import { findStoreysByProjectAndSortByElevation } from '@/declare/api/storey';
import { message } from 'antd';
import { PythaEventStringArray, UpdateType } from 'pytha2';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { findSecondGroupsByParamType, getGroups } from '@/declare/api/group';
import { GroupParamType } from '@/declare/enums/group-param-type';
import { Group } from '@/declare/interface/group';
import { Storey } from '@/declare/interface/storey';

interface Layers {
    uuid: string,
    selectedUrl: string,
    unselectedUrl: string,
    x: number,
    y: number,
    width: number,
    height: number,
    zIndex: number,
    name: string,
    groupUuid: string
    groupUuids: string[]
}

interface IProps {

}

export default function ExplodedViewPanel(props: IProps) {
    const { monixProjectId, bimProjectId, bimModelUuid } = useParams(); // 路由参数
    const systemContext = useContext(SystemContext); // 系统上下文
    const engineContext = useContext(EngineContext); // 引擎上下文
    const [groups, setGroups] = useState<Group[]>([]); // 组列表
    const [layers, setLayers] = useState<Layers[]>([]); // 爆炸图图层列表
    const [activeLayer, setActiveLayer] = useState<any>(null); // 激活的爆炸图图层

    useEffect(() => {
        axios.all([getGroups(bimProjectId), findStoreysByProjectAndSortByElevation(bimProjectId)]).then(([res1, res2]) => {

            let groups: Group[] = res1.data || [];
            setGroups(groups);

            let storeys: Storey[] = res2.data || [];
            let layers: Layers[] = storeys?.map((item, idx) => {
                return {
                    uuid: item.uuid,
                    selectedUrl: item?.grouping?.selectedBase64,
                    unselectedUrl: item?.grouping?.unselectedBase64,
                    x: 0,
                    y: 30 * idx,
                    width: 135,
                    height: 45,
                    zIndex: storeys?.length - idx,
                    name: item?.grouping?.name,
                    groupUuid: item?.grouping?.uuid,
                    groupUuids: getGroupAndDescendantsUuids(groups, item?.grouping?.uuid)
                }
            })
            setLayers(layers);

        }).catch(err => {
            console.log('err', err)
            message.error("获取示意图数据失败");
        })
    }, [])

    /**
     * 递归获取本身及子孙的uuid
     * @param groups 
     * @param targetUuid 
     * @returns 
     */
    const getGroupAndDescendantsUuids = (groups: Group[], targetUuid: string): string[] => {
        const result: string[] = [];

        // 递归查找子孙组的 uuid
        const findDescendants = (uuid: string) => {
            const group = groups?.find(g => g.uuid === uuid); // 查找当前组
            if (group) {
                result.push(group.uuid!); // 将当前组的 uuid 加入结果列表
                // 查找所有子组
                groups.filter(g => g.parentUuid === uuid).forEach(child => {
                    findDescendants(child.uuid!); // 递归处理子组
                });
            }
        };

        findDescendants(targetUuid); // 从目标组开始查找
        return result;
    };

    /**
     * 点击某图层
     * @param layer 
     * @returns 
     */
    const onClickLayer = (layer: Layers) => {
        let equals = false; // 和上一次点击的是否相同
        if (activeLayer?.uuid === layer?.uuid) {
            equals = true;
            setActiveLayer(null);
            systemContext.setActiveGroupUuids(groups?.map(g => g.uuid) || []);
        } else {
            setActiveLayer(layer);
            let activeGroupUuids: string[] = getGroupAndDescendantsUuids(groups, layer?.groupUuid);
            systemContext.setActiveGroupUuids(activeGroupUuids);
        }

        if (!engineContext?.engine) return;

        // 按组显示
        let needRenderKeys = layer?.groupUuids || [];
        let excludeKeys = [];
        let hiddenDefine = false;
        let objectRenderBucket = engineContext.engine.storage.renderStore.objectRenderBucket;
        if (equals) {
            // 显示全部图元
            // engineContext.emitCommand("SHOW_ALL");
            for (let key in objectRenderBucket) {
                for (let mapItem of objectRenderBucket[key].renderBucketItems) {
                    mapItem.hidden = false;
                    if (mapItem.object && !mapItem.object.parent) {
                        engineContext.engine.storage.viewportStore.scene.add(mapItem.object);
                    }
                }
            }
            engineContext.engine.eventMediator.renderHandler.render(true, UpdateType.ALL);
        } else {
            for (let key in objectRenderBucket) {
                for (let mapItem of objectRenderBucket[key].renderBucketItems) {
                    let needHidden = true;
                    for (let i = 0; i < needRenderKeys?.length; i++) {
                        const mappingKey = needRenderKeys[i]; // 用来匹配的key
                        if (key.includes(mappingKey) && !!!excludeKeys?.find(item => key.includes(item))) {
                            //匹配上传入的key的值才会显示
                            needHidden = false;
                            if (!hiddenDefine) {
                                mapItem.hidden = false;
                            }
                            if (mapItem.object && !mapItem.object.parent) {
                                engineContext.engine.storage.viewportStore.scene.add(mapItem.object);
                            }
                            break;
                        }
                    }
                    if (needHidden) {
                        //如果没有匹配上，则需要将其隐藏
                        mapItem.hidden = true;
                    }
                }
            }
            engineContext.engine.eventMediator.renderHandler.render(true, UpdateType.ALL);
            // if (needRenderKeys?.length > 0) {

            // }

            // const event = new PythaEventStringArray();
            // event.data = layer?.groupUuids || [];
            // engineContext.emitCommand("GROUPSHOW")
            // engineContext.engine.eventMediator?.emitEvent(event);
        }

        // if (equals) {
        //     // 显示全部图元
        //     engineContext.emitCommand("SHOW_ALL");
        //     return;
        // } else {
        //     // 按组显示
        //     const event = new PythaEventStringArray();
        //     event.data = layer?.groupUuids || [];
        //     engineContext.emitCommand("GROUPSHOW")
        //     engineContext.engine.eventMediator?.emitEvent(event);
        // }
    }

    return (
        <div className='exploded-view-container'>
            <div className='type-row'>
                {MonitorObjectTypeList.map(item => (
                    <div
                        className={classNames({
                            'type-block': true,
                            'type-block-cancel': !systemContext.monitorObjectTypeList?.some(t => t === item.value),
                        })}
                        style={{ color: item.color }}
                        onClick={() => systemContext.toggleMonitorObjectType(item.value)}
                    >
                        <item.icon />
                        {item.label}
                    </div>
                ))}
            </div>
            <div className='exploded-view-panel'>
                {/* 画布容器 */}
                <div
                    className='exploded-block'
                // style={{
                //     width: canvasSize.width,
                //     height: canvasSize.height
                // }}
                >
                    {layers?.map((layer, index) => (
                        <div
                            key={layer.uuid}
                            onClick={() => onClickLayer(layer)}
                        >
                            <div
                                className={classNames({
                                    'layer-name': true,
                                    'layer-name-active': activeLayer?.uuid === layer?.uuid,
                                })}
                                style={{
                                    left: layer.x + 5,
                                    top: layer.y + 15,
                                    zIndex: layer.zIndex,
                                }}
                            >
                                <div className='span'>{layer?.name}</div>
                            </div>
                            <div
                                className='layer-img'
                                style={{
                                    left: layer.x + 7.5 + 60,
                                    top: layer.y,
                                    zIndex: layer.zIndex,
                                }}
                            >
                                <img
                                    src={activeLayer?.uuid === layer?.uuid ? (layer.selectedUrl || '') : (layer.unselectedUrl || '')}
                                    style={{
                                        width: layer.width,
                                        height: layer.height
                                    }}
                                />
                            </div>
                            <div
                                className='layer-img'
                                style={{
                                    left: layer.x + 60,
                                    top: layer.y,
                                    zIndex: layer.zIndex,
                                }}
                            >
                                <img
                                    src={activeLayer?.uuid === layer?.uuid ? Blue : Gray}
                                    style={{
                                        width: 150,
                                        height: 48
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}